module.exports = __webpack_public_path__ + "img/emamRezaDetails1.38683c51.png";